import {
	StyleSheet,
	FlatList,
	View,
	SafeAreaView,
	Text,
	Pressable,
	ScrollView,
	RefreshControl,
} from "react-native";
import HighlightedDiscountsRail from "../../../components/HighlightedDiscountsRail";
import React, { useEffect, useState } from "react";
import DiscountsForYouRail from "../../../components/DiscountsForYouRail";
import FoodDiscountsRail from "../../../components/FoodDiscountsRail";
import AllDiscounts from "./AllDiscounts";
import useApi from "../../../hooks/useAPI";
import { useQuery } from "react-query";
import { useTheme, Menu, Button, Divider, Provider } from "react-native-paper";
import { Entypo } from "@expo/vector-icons";
import FilterBar from "./FilterBar";
import FilteredDiscounts from "./FilteredDiscounts";
export interface Filters {
	category: string;
	region: string;
	isicType: string;
	storeType: string;
	showRails: boolean;
}
const Discounts = ({ navigation }) => {
	const api = useApi();
	// todo CHANGE FROM useState TO useRedux
	const [allDiscounts, setAllDiscounts] = useState([]);
	const [highlightDiscountsIds, setHighlightDiscountsIds] = useState([]);
	const [highlightDiscounts, setHighlightDiscounts] = useState([]);
	const [refreshing, setRefreshing] = useState(false);
	const [data, setData] = useState([]);

	const filters = {
		category: "Todas",
		isicType: "Todas",
		region: "Todas",
		storeType: "Todas",
		showRails: true,
	};
	const [selectedFilters, setSelectedFilters] = useState<Filters>(filters);

	async function onRefresh() {
		await Promise.all([refetchServices(), refetchHighlights()]);
	}
	const { isLoading: servicesLoading, refetch: refetchServices } = useQuery(
		"services",
		() => api.services.getAllDocuments(),

		{
			onSuccess: async res => {
				await setAllDiscounts(res.data);
			},
			onError: async (e: any) => {
				console.log("erro na disct");
			},
		}
	);
	const { isLoading: loadingHighlight, refetch: refetchHighlights } = useQuery(
		"highlights",
		() => api.services.getHighlightIds(),
		{
			onSuccess: async res => {
				console.log("antes", highlightDiscountsIds);
				await setHighlightDiscountsIds(res.data);
			},
			onError: async (e: any) => {
				console.log("erro na get highlight");
			},
		}
	);

	useEffect(() => {
		if (
			!servicesLoading &&
			!loadingHighlight &&
			allDiscounts.length > 0 &&
			highlightDiscountsIds.length > 0
		) {
			getHighlightDiscounts();
		}
	}, [allDiscounts, highlightDiscountsIds]);

  function getHighlightDiscounts() {
    const inOrder = highlightDiscountsIds
      .map((id) => allDiscounts.find((discount) => discount.id === id))
      .filter((object) => object !== undefined);
    setHighlightDiscounts(inOrder);
  }

  return (
    <View style={styles.root}>
      <FilterBar
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
      />
      <ScrollView
        style={styles.container}
        refreshControl={
          <RefreshControl
            refreshing={refreshing}
            onRefresh={onRefresh}
            progressBackgroundColor="##F3F3F3"
            progressViewOffset={-20}
            colors={["rgb(8, 123, 245)"]}
            tintColor={"rgb(8, 123, 245)"}
          />
        }
      >
        {selectedFilters.showRails &&
        selectedFilters.category === "Todas" &&
        selectedFilters.isicType === "Todas" &&
        selectedFilters.region === "Todas" &&
        selectedFilters.storeType === "Todas" ? (
          <View>
            <HighlightedDiscountsRail
              style={{ paddingTop: 20, zIndex: 1 }}
              highlightDiscounts={highlightDiscounts}
              navigation={navigation}
            />
            <DiscountsForYouRail />
            <FoodDiscountsRail
              navigation={navigation}
              foodDiscounts={allDiscounts.filter((item) =>
                item?.category?.find((item) => item === "Alimentação")
              )}
              setSelectedFilters={setSelectedFilters}
            />
            <AllDiscounts
              allDiscounts={allDiscounts}
              navigation={navigation}
              setSelectedFilters={setSelectedFilters}
            />
          </View>
        ) : (
          <FilteredDiscounts
            allDiscounts={allDiscounts}
            navigation={navigation}
            selectedFilters={selectedFilters}
          />
        )}
      </ScrollView>
    </View>
  );
};

export default Discounts;

const styles = StyleSheet.create({
	root: { flex: 1, zIndex: 5 },
	container: { zIndex: 1 },
});
